import script from "./AdminNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNavbar.vue?vue&type=script&setup=true&lang=js"

import "./AdminNavbar.vue?vue&type=style&index=0&id=2fc62aee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc62aee"]])

export default __exports__